export const mobileBannerHeight = 48;
export const BANNER_NAME = 'RETURN_TO_MOBILE_BANNER';
export const ENCODED_APPLE_APP_STORE_URL = encodeURIComponent(
	'https://itunes.apple.com/app/apple-store/id1006972087',
);
